import type { ReactNode } from 'react';

import { CloseButton } from '@/components/common/close-button';

import styles from './overlay-chrome.module.scss';
import { OverlayPattern } from './overlay-pattern';

export type OverlayChromeProps = {
  /** When set, renders the cream header band with title + pattern. */
  title?: ReactNode;
  onClose: () => void;
  closeAriaLabel?: string;
  /** Footer node (typically <OverlayFooter />). Omitted when absent. */
  footer?: ReactNode;
  /** When provided, body + footer are wrapped in a <form> with this handler. */
  onSubmit?: React.ComponentProps<'form'>['onSubmit'];
  children: ReactNode;
};

export function OverlayChrome({
  title,
  onClose,
  closeAriaLabel = 'Close',
  footer,
  onSubmit,
  children,
}: OverlayChromeProps) {
  const inner = (
    <>
      {title != null ? (
        <header className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
          <OverlayPattern />
        </header>
      ) : null}
      <div className={styles.body}>{children}</div>
      {footer ? <div className={styles.footerRegion}>{footer}</div> : null}
    </>
  );

  return (
    <div className={styles.content}>
      <CloseButton aria-label={closeAriaLabel} onClick={onClose} className={styles.close} />
      {onSubmit ? (
        <form className={styles.form} onSubmit={onSubmit} noValidate>
          {inner}
        </form>
      ) : (
        inner
      )}
    </div>
  );
}
